"use client";

import { useState } from "react";
import Link from "next/link";

import { AgentReadyUrlForm } from "~/components/siteglue/agent-ready/scan-form";
import { trackSiteGlueEvent } from "~/lib/siteglue/cta-config";
import {
  HOMEPAGE_BUILD_CTA,
  HOMEPAGE_SCAN_CTA,
  HOMEPAGE_URL_PLACEHOLDER,
} from "~/lib/siteglue/landing-redesign/copy";
import { trackLandingEvent } from "~/lib/siteglue/landing-redesign/events";

export function HomeHeroScanForm({
  onStepChange,
}: {
  onStepChange?: (step: number) => void;
} = {}) {
  const [step, setStep] = useState(0);

  return (
    <div className="w-full max-w-2xl">
      <AgentReadyUrlForm
        className="mx-0 mt-0 max-w-none text-left"
        urlPlaceholder={HOMEPAGE_URL_PLACEHOLDER}
        stepZeroCta={HOMEPAGE_SCAN_CTA}
        hideSteps
        urlOnly
        onStepChange={(next) => {
          if (step === 0 && next === 1) {
            trackLandingEvent("url_submit", { url_source: "homepage_hero" });
          }
          setStep(next);
          onStepChange?.(next);
        }}
      />
      {step === 0 ? (
        <>
          <Link
            href="/start"
            onClick={() => trackSiteGlueEvent("homepage_primary_cta_click", { destination: "/start" })}
            className="mt-4 inline-flex h-11 w-full items-center justify-center rounded-full border border-slate-300 bg-white px-5 text-sm font-semibold text-slate-900 hover:bg-slate-50 sm:w-auto"
          >
            {HOMEPAGE_BUILD_CTA}
          </Link>
        </>
      ) : null}
    </div>
  );
}
